module.exports = __webpack_public_path__ + "static/media/trachea.f00a9a81.ogg";